import { render, staticRenderFns } from "./ModalBackup.vue?vue&type=template&id=074c6000&"
import script from "./ModalBackup.vue?vue&type=script&lang=js&"
export * from "./ModalBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports